import loadable from 'utils/loadable';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "modal.playresponsibly.monthlyrechargelimit.responsemodal" */ 'pages/PlayResponsabilityPage/partials/SEU/take-a-break/components/deposit-unavailable-modal/deposit-unavailable-modal.component'
    ),
);
